import {IRouteChanged, subscribeToRouteChanged} from "../eventBus/route/routeEventBus";
import {appPagePaths, appRoutePaths, settingsPagePaths} from "../../config/config";
import settingsService from "./settingsService";
import {userAuthentication} from "../user/authentication";
import {logger} from "../log/logger";
import {settingsPageStore} from "../../redux/settingsPage/settingsPageStore";
import {SettingsPageSection} from "../../redux/settingsPage/settingsPageTypes";

class SettingsPage {
  unsubscribeFuncs: (() => void)[];

  constructor() {
    this.unsubscribeFuncs = [
      subscribeToRouteChanged(this.onRoute_change.bind(this)),
    ];
  }

  async onRoute_change({routePath, locationPath, userHasValidToken}: IRouteChanged): Promise<void> {
    if(appRoutePaths.settingsPage !== routePath || !userHasValidToken)
    {
      return;
    }

    const selectedSectionFromLocationPath = getSettingsSectionFromLocationPath(locationPath);
    settingsPageStore.setSelectedSection(selectedSectionFromLocationPath);
  }

  changeVirtualPianoNumberOfKeys(count: number){
    settingsService.changeVirtualPianoNumberOfKeys(count);
  }

  /**
   * @deprecated use the useNavigate hook instead of using window.location.hash directly
   * Failing that, use the custom navigate() function we made, until the useNavigate hook is easier to integrate here.
   */
  signOut(){
    userAuthentication.signOut();
    window.location.hash = appPagePaths.signIn;
  }
}

function getSettingsSectionFromLocationPath(locationPath: string,): SettingsPageSection {
  const parts = locationPath.split("/"); //should result in ["", "settings", "myAccount", ]
  logger.routerCustomMatch.debug({message: `settings Section Location Path` + parts.toString()});
  let settingsSection: SettingsPageSection = "keyboardAndVolumes";
  if(parts.length >= 3) {
    const settingsSectionPart = parts[2];
    logger.routerCustomMatch.debug({message: `settings section part: ` + settingsSectionPart});
    const matchingEntry = Object.entries(settingsPagePaths).find(([_key, value]) => value.indexOf(settingsSectionPart) >= 0);
    logger.routerCustomMatch.debug({message: `matching entry: ` + matchingEntry});
    if(matchingEntry !== undefined){
      settingsSection = matchingEntry[0] as SettingsPageSection;
    }
  }
  return settingsSection;
}

const settingsPage = new SettingsPage();

export default settingsPage;
